var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchableTable',{attrs:{"panel-header":'Gruppen',"panel-route":'AddGroup',"show-search-bar":true,"table-data":_vm.groupArrayFiltered,"table-meta-data":_vm.tableMetaData,"query-string":'setGroupSearchQuery',"initial-search-query":_vm.groupSearchQuery,"row-click":_vm.triggerView,"default-sort":['attributes.group_name', 'asc']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }